<template>
    <div class="card">
        <div class="card-body">
            <div class="d-flex justify-content-between">
                <div class="search-block">
                    <div class="btn-group">
                        <AppButton :color="$route.name === 'OrdersTablePage' ? 'indigo' : 'light'" @click="switchView('OrdersTablePage')">
                            <i class="icon-menu7"></i>
                        </AppButton>
                        <AppButton :color="$route.name === 'OrdersKanbanPage' ? 'indigo' : 'light'" @click="switchView('OrdersKanbanPage')">
                            <i class="icon-menu7" style="transform: rotate(90deg);"></i>
                        </AppButton>
                    </div>
                    <div class="btn-group">
                        <button type="button" :class="['btn', 'dropdown-toggle', selectedOrderUuids.length === 0 ? 'btn-light' : 'bg-indigo']" data-toggle="dropdown" aria-expanded="false" :disabled="selectedOrderUuids.length === 0">
                            {{ $t('labels.actions') + (selectedOrderUuids.length > 0 ? ` (${selectedOrderUuids.length})` : '') }}
                        </button>
                        <div class="dropdown-menu dropdown-menu-left" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(123px, 38px, 0px);">
                            <DropdownItem @click="$refs.PrintDocumentModal.show(selectedOrderUuids, sortOrders)">
                                {{ $t('buttons.print') }}
                            </DropdownItem>
                            <DropdownItem @click="$refs.EditOrdersModal.show(selectedOrderUuids)">
                                {{ $t('buttons.edit') }}
                            </DropdownItem>
                            <DropdownItem @click="deleteOrders">
                                {{ $t('buttons.delete') }}
                            </DropdownItem>
                        </div>
                    </div>
                    <InputGroup style="width: 250px">
                        <template #prepend>
                            <span class="input-group-text"><i class="icon-search4"></i></span>
                        </template>
                        <Input
                            :model-value="search"
                            @update:model-value="$emit('update:search', $event)"
                            type="text"
                            :placeholder="$t('labels.search')"
                        />
                    </InputGroup>
                    <button type="button" class="btn btn-light" @click="$emit('fetch:orders')">
                        <i class="icon-reload-alt"></i>
                    </button>
                    <div class="btn-group">
                        <button type="button" class="btn bg-light" @click="$refs.OrdersFiltersModal.show()">
                            <i class="icon-filter3"></i>
                            <span v-if="activeFiltersCount > 0"> ({{ activeFiltersCount }})</span>
                        </button>
                        <button type="button" class="btn btn-icon btn-danger" v-if="activeFiltersCount > 0" @click="$refs.OrdersFiltersModal.clear()">
                            <i class="icon-cross2"></i>
                        </button>
                    </div>
                </div>
                <div class="d-flex flex-wrap" style="gap: .5rem">
                    <div class="btn-group" v-if="$route.name === 'OrdersKanbanPage'">
                        <AppButton :color="massActionsIsOn ? 'indigo' : 'light'" @click="updateMassActionsState(!massActionsIsOn)">
                            <i class="icon-checkbox-checked mr-2"></i>{{ $t('labels.mass_actions') }}
                        </AppButton>
                    </div>
                    <button type="button" class="btn btn-light" :disabled="exporting" @click="exportOrders">
                        <i :class="['mr-2', exporting ? 'icon-spinner2 spinner' : 'icon-download7']"></i>
                        {{ $t('buttons.export') }}
                    </button>
                    <router-link
                        class="btn bg-indigo"
                        :to="{
                            name: 'OrderCreatePage'
                        }"
                    >
                        <i class="icon-plus3 mr-2"></i>
                        {{ $t('buttons.create') }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
    <EditOrdersModal ref="EditOrdersModal" @update:table="$emit('fetch:orders')"/>
    <OrdersFiltersModal ref="OrdersFiltersModal" @update:filters="(f, c, s) => $emit('update:filters', f, c, s)"/>
    <PrintDocumentModal ref="PrintDocumentModal"/>
</template>
<script>
import ButtonDropdown from "../../../../components/btnDropdown/ButtonDropdown.vue";
import DropdownItem from "../../../../components/btnDropdown/DropdownItem.vue";
import InputGroup from "../../../../../components/new/form/InputGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import EditOrdersModal from "../modals/EditOrdersModal.vue";
import OrdersFiltersModal from "./OrdersFiltersModal.vue";
import AppButton from "../../../../../components/new/button/AppButton.vue";
import PrintDocumentModal from "../modals/PrintDocumentModal.vue";

import qs from "qs";

import MessageNotificator from "../../../../../services/MessageNotificator";
import HttpSender from "../../../../../services/Http/HttpSender.ts";
import HttpRequest from "../../../../../services/Http/HttpRequest.ts";
import { httpClient } from "../../../../../services/HttpClient.ts";

export default {
    name: 'OrdersTopBarCard',
    components: {
        ButtonDropdown, DropdownItem, InputGroup, Input, EditOrdersModal, OrdersFiltersModal, AppButton,
        PrintDocumentModal
    },
    emits: ['fetch:orders', 'update:filters', 'update:search', 'mass-actions-state-changed'],
    props: {
        selectedOrderUuids: {
            type: Array,
            required: true
        },
        sortOrders: {
            type: Array,
            required: true
        },
        search: {
            type: String,
            required: true
        },
        activeFiltersCount: {
            type: Number,
            required: true
        },
        filters: {
            type: Object,
            default: () => ({})
        },
        orders: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            massActionsIsOn: false,
            exporting: false
        }
    },
    methods: {
        async deleteOrders() {
            new MessageNotificator().confirm(this.$t('alerts.delete_crm_order'), async () => {
                let requests = [];

                for (const orderUuid of this.selectedOrderUuids) {
                    requests.push(new HttpRequest(
                        'DELETE',
                        `/projects/${this.$route.params.projectUuid}/crm/orders/${orderUuid}`
                    ));
                }

                await new HttpSender().sendRequestsInBatches(requests, () => {})

                new MessageNotificator().success(this.$t('alerts.success'))
                this.$emit('fetch:orders');
            })
        },
        async exportOrders() {
            if (this.exporting) {
                return;
            }

            this.exporting = true;

            const request = {
                search: this.search,
                orders: this.orders,
                ...this.filters
            };

            try {
                const response = await httpClient.get(
                    `/projects/${this.$route.params.projectUuid}/crm/orders/export`,
                    request,
                    false,
                    'blob'
                );

                this.downloadFile(response);
            } catch (e) {
                new MessageNotificator().warning(this.$t('alerts.server_error'));
            } finally {
                this.exporting = false;
            }
        },
        downloadFile(response) {
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);

            const disposition = response.headers['content-disposition'] ?? '';
            const match = disposition.match(/filename="?([^"]+)"?/);
            const fileName = match ? match[1] : `orders_${new Date().toISOString().slice(0, 10)}.xlsx`;

            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        },
        switchView(name) {
            if (this.$route.name === name) {
                return;
            }

            const query = { ...this.filters };
            if (this.search) query.search = this.search;

            const queryString = qs.stringify(query);
            this.$router.push(queryString ? `${this.$router.resolve({ name }).path}?${queryString}` : { name });
        },
        updateMassActionsState(isOn) {
            this.massActionsIsOn = isOn;
            this.$emit('mass-actions-state-changed', isOn);
        },
        restoreFilters(fieldsState) {
            this.$refs.OrdersFiltersModal.queueRestore(fieldsState);
        },
    }
}
</script>
<style scoped>
.search-block {
    display: flex;
    gap: 10px;
}
.ot-seg {
    display: inline-flex;
    border: 1px solid #ddd;
    border-radius: .1875rem;
    overflow: hidden;
}
.ot-seg button {
    border: 0;
    background: #fff;
    color: #777;
    cursor: pointer;
    height: 38px;
    width: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all ease-in-out .15s;
}
.ot-seg button.is-active {
    background: #3F51B5;
    color: #fff;
}
.ot-act {
    height: 38px;
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #e2e0e0;
    border-radius: .1875rem;
    background: #f5f4f4;
    color: #555;
    cursor: pointer;
    font-size: 13px;
    transition: all ease-in-out .15s;
}
.ot-act.is-on {
    background: #3F51B5;
    border-color: #3F51B5;
    color: #fff;
}
</style>